{
  "organization": "Organisation",
  "tabs": {
    "apiTokens": "Jetons API",
    "embeddedWebApp": "WebApp intégrée",
    "integrations": "Intégrations",
    "webHooks": "Liens de rappel HTTP"
  },
  "apiTokenTable": {
    "name": "Nom",
    "noPermissions": "# Autorisations",
    "organization": "Organisation",
    "state": "État",
    "actions": "Actions"
  },
  "apiTokenModal": {
    "title": "Créer nouveau jeton API",
    "name": "Nom",
    "organization": "Organisation",
    "permissions": "Autorisations"
  },
  "viewApiToken": "Voir l'en-tête d'autorisation",
  "deactivate": "Désactiver",
  "deactivated": "Désactivé",
  "active": "Actif",
  "update": "Mettre à jour",
  "edit": "Modifier",
  "cancel": "Annuler",
  "editApiTokenModal": {
    "title": "Modifier le jeton API",
    "save": "Enregistrer"
  },
  "orgInfo": {
    "organizationId": "ID d'organisation",
    "partnerJWK": "Partenaire JWK",
    "webAppURL": "Application Web URL"
  },
  "integrationsTable": {
    "type": "Type",
    "name": "Nom",
    "provider": "Fournisseur",
    "organization": "Organisation",
    "organizationSetting": "Paramètre de l'organisation",
    "actions": "Actions",
    "state": "État",
    "active": "Actif",
    "inactive": "Inactif"
  },
  "integrationsTableOptions": {
    "type": {
      "ADDRESS": "Adresse",
      "ANALYTICS": "Analyse",
      "BANKING": "Banque",
      "FINANCIAL_DATA_WIDGETS": "Gadgets logiciels de données financières",
      "ID_VERIFICATION": "Vérification d'identité",
      "MARKET_DATA": "Données sur le marché",
      "DATA_INGESTION": "Ingestion de données",
      "STATISTICS": "Statistiques",
      "ACCOUNT_DETAILS": "Détails du compte",
      "FORM": "Intégration Formulaires",
      "CHAT_AGENT": "Agent de discussion",
      "FRAUD_DETECTION": "Détection de la fraude",
      "PASSTHROUGH_API": "API de la passerelle",
      "ACCOUNT_OPENING": "Ouverture de compte"
    },
    "default": "Par défaut",
    "provider": {
      "CANADA_POST": "Postes Canada",
      "FLINKS": "Flinks",
      "PLAID": "Plaid",
      "GOOGLE": "Google",
      "FIREBASE": "Firebase",
      "IEX_CLOUD": "IEX Cloud",
      "LSEG": "LSEG",
      "MIXPANEL": "Mixpanel",
      "PERSONA": "Persona",
      "QUOTE_MEDIA": "Quote Media",
      "ENVESTNET": "Envestnet",
      "ATB": "ATB",
      "ONESPAN": "ONESPAN",
      "DOCUSIGN": "DOCUSIGN",
      "ZENDESK": "ZENDESK",
      "SIMILITY": "SIMILITY",
      "SCHWAB": "Schwab",
      "none": "Aucun",
      "NBIN": "NBIN"
    },
    "organizationSetting": {
      "notInherited": "Non hérité",
      "inherited": "Hérité"
    },
    "viewDataIngestionRequests": "Voir les demandes"
  },
  "integrationsModal": {
    "title": "Créer une intégration",
    "editTitle": "Modifier l'intégration",
    "provider": "Fournisseur",
    "type": "Type",
    "configuration": {
      "clientIframeUrl": "URL IFrame client",
      "customerId": "Identifiant du client",
      "processorName": "Nom du processeur",
      "instanceId": "Identifiant de l'instance",
      "plaidSecret": "Secret Plaid",
      "enableNameMatching": "Activer le rapprochement des noms",
      "templateId": "Identifiant du modèle",
      "verificationPassedWebhookSecret": "Vérification réussie du secret du lien de rappel HTTP",
      "inquiryUpdateWebhookSecret": "Mise à jour de l'enquête du secret du lien de rappel HTTP",
      "accountBaseUri": "URI de base du compte",
      "apiAccountId": "Identifiant de compte de l'API",
      "accountUserId": "Identifiant de l'utilisateur du compte",
      "integrationKey": "Clé d'intégration",
      "integrationRsaPrivateKey": "Clé privée RSA d'intégration",
      "connectSecretKey": "Clé secrète de connexion à Docusign",
      "apiKey": "Clé API",
      "apiToken": "Jeton API",
      "TBD": "À déterminer",
      "user": "Utilisateur",
      "password": "Mot de passe",
      "baseUrl": "URL de base",
      "authDomain": "Domaine d'authentification",
      "projectId": "Identifiant du projet",
      "messagingSenderId": "Identifiant de l'expéditeur du message",
      "appId": "Identifiant de l'application",
      "measurementId": "Identifiant de la mesure",
      "privateKey": "Clé privée",
      "publicKey": "Clé publique",
      "username": "Nom d'utilisateur",
      "name": "Nom",
      "widgetUsername": "Nom d'utilisateur de l'API Widgets",
      "widgetName": "Nom de l'API Widgets",
      "widgetPrivateKey": "Clé privée de l'API Widgets",
      "widgetPublicKey": "Clé publique de l'API Widgets",
      "rdpUsername": "Nom d'utilisateur de l'API RDP",
      "rdpPassword": "Mot de passe de l'API RDP",
      "rdpClientId": "ID du client de l'API RDP",
      "webmasterId": "ID du webmestre",
      "clientRoleKey": "Clé de rôle client",
      "advisorRoleKey": "Clé du rôle de conseiller",
      "pageKeys": "Clés de page",
      "fnclsValue": "Valeur FNCLS",
      "scriptInjectURL": "URL d'injection de script",
      "token": "Jeton",
      "netWorthAutomaticLinkingUrl": "URL de liaison automatique de la valeur nette",
      "netWorthAutomaticLinkingToken": "Jeton de liaison automatique de la valeur nette",
      "netWorthAutomaticLinkingNotificationGroup": "Groupe de notifications de liaison automatique de la valeur nette",
      "senderEmail": "Adresse e-mail de l'expéditeur",
      "packageNameTemplate": "Modèle de nom de package",
      "packageMetadataTemplate": "Modèle d'objet de métadonnées de paquet",
      "masterAccountIds": "ID des comptes principaux",
      "enableSftp": "Activer SFTP",
      "sftpHost": "Hôte SFTP",
      "sftpPort": "Port SFTP",
      "sftpUsername": "Nom d'utilisateur SFTP",
      "sftpPassword": "Mot de passe SFTP",
      "sftpPrivateKey": "Clé privée SFTP",
      "sftpPassphrase": "Phrase secrète SFTP",
      "sftpSendRootDir": "Répertoire racine d'envoi SFTP",
      "sftpReceiveRootDir": "Répertoire racine de réception SFTP",
      "accountIdPrefix": "Préfixe d'identifiant de compte NBIN",
      "firmIdentifier": "Identifiant de la firme",
      "divisionCode": "Code de division"
    },
    "attributes": {
      "passthroughApiUrl": "URL de l'API de la passerelle",
      "passthroughApiPrivateSecretName": "Nom de la variable de la clé privée utilisée pour générer le jeton d'autorisation"
    },
    "scopeOptions": {
      "DATA_INGESTION": {
        "ORGANIZATION": "Organisations",
        "HOUSEHOLD": "Ménages",
        "ENTITY": "Entités",
        "ORGANIZATION_USER": "Profils d'authentification",
        "ACCOUNT": "Comptes",
        "SUB_ACCOUNT": "Sous-comptes",
        "GOAL": "Objectifs",
        "TRANSACTION": "Transactions",
        "CASH_AND_HOLDINGS": "Liquidités et actifs",
        "ASSET_CLASS": "Catégories d'actifs",
        "FINANCIAL_PRODUCT": "Étagère de produits",
        "MODEL_PORTFOLIO": "Portefeuilles modèles",
        "STATS_HISTORY": "Instantanés historiques",
        "PRICE_HISTORY": "Instantanés de prix",
        "PERFORMANCE_HISTORY": "Instantanés des résultats",
        "TRANSFER": "Virements",
        "TRADE": "Opérations",
        "SUB_TRADE": "Sous-opérations",
        "SCHEDULED_TRANSFER": "Virements programmés",
        "CUSTODIAN_ACTIVITY": "Activités du dépositaire",
        "CUSTODIAN_CASH_AND_HOLDINGS": "Trésorerie et avoirs du dépositaire",
        "BANK_ACCOUNT": "Comptes bancaires",
        "ACCOUNT_GROUP": "Groupes de comptes"
      },
      "PASSTHROUGH_API": {
        "TRANSACTION": "Transactions",
        "CASH_AND_HOLDINGS": "Liquidités et actifs",
        "STATS_HISTORY": "Instantanés historiques",
        "PROJECTED_INCOME": "Revenu projeté",
        "PERFORMANCE": "Résultats",
        "LIVE_PRICING": "Tarification courante",
        "ENTITY": "Entités",
        "ACCOUNT": "Comptes",
        "PRODUCT_SHELF": "Étagère de produits",
        "BANK_ACCOUNT": "Compte bancaire",
        "HOUSEHOLD": "Ménages",
        "STATEMENT": "Relevés"
      },
      "STATISTICS": {
        "holdings": "Actifs",
        "timeWeightedReturn": "Taux de rendement pondéré dans le temps (TWRR)",
        "moneyWeightedReturn": "Taux de rendement pondéré (MWRR)",
        "simpleRateOfReturn": "Taux de rendement simple",
        "projectedIncome": "Revenu projeté",
        "historySnapshots": "Instantanés historiques",
        "contributions": "Contributions"
      }
    },
    "successToastMessage": "L'interaction a été correctement mise à jour."
  },
  "integrationsDeleteModal": {
    "title": "Supprimer cette intégration?",
    "body": "Voulez-vous vraiment supprimer cette intégration?"
  },
  "webHooksTable": {
    "type": "Type",
    "objects": "Objets",
    "organization": "Organisation",
    "organizationSetting": "Paramètre de l'organisation",
    "actions": "Actions"
  },
  "webHooksTableOptions": {
    "type": {
      "GRAPHQL": "GraphQL",
      "REST": "REST"
    },
    "objectType": {
      "Account": "Compte",
      "AccountStatement": "Relevé de compte",
      "AdministrativeAnnualFeeReport": "Rapport annuel sur les frais administratifs",
      "BankAccount": "Compte bancaire",
      "ManagementAnnualFeeReport": "Rapport annuel sur les frais de gestion",
      "ScheduledTransfer": "Virement programmé",
      "SubAccount": "Sous-compte",
      "TaxSlip": "Feuillet de renseignements fiscaux",
      "Transfer": "Virement",
      "User": "Utilisateur",
      "OrganizationUser": "Utilisateur de l'organisation",
      "BulkTradeRun": "Réalisation d'opération groupée"
    }
  },
  "WebHookModal": {
    "title": "Créer un lien de rappel HTTP",
    "editTitle": "Modifier le lien de rappel HTTP",
    "type": "Type",
    "organization": "Organisation",
    "objectType": "Type d'objet",
    "customHeader": "En-tête personnalisé",
    "eventType": "Type d'événement",
    "graphQL": "GraphQL",
    "url": "URL",
    "payloadAttributes": "Attributs de charge utile",
    "signedJWTHeader": "En-tête JWT signée",
    "mutationName": "Nom de la mutation",
    "mutationInputName": "Nom d'entrée de la mutation",
    "customHeaderKey": "Clé d'en-tête personnalisée",
    "customHeaderValue": "Valeur d'en-tête personnalisée",
    "payloadAttributeKey": "Clé d'attribut de charge utile",
    "payloadAttributeValue": "Valeur d'attribut de charge utile",
    "successToastMessage": "Les liens de rappel HTTP ont été correctement mis à jour.",
    "addAttributeBtn": "Ajouter",
    "deleteSuccessToastMessage": "Le lien de rappel HTTP a été correctement supprimé",
    "delete": "Supprimer",
    "deleteWebHookTitle": "Confirmez-vous?",
    "deleteWebHookBody": "Vous ne pourrez pas récupérer ce lien de rappel HTTP et vous devrez en ajouter un autre."
  },
  "successToastMessage": "URL JWT a été correctement mis à jour",
  "bulkUpsertRequest": {
    "table": {
      "objectType": "Type d'objet",
      "state": "État",
      "createdAt": "Exécuté à",
      "ranBy": "Exécuté par",
      "queuedItemsCount": "En fille d'attente",
      "failedItemsCount": "Échec",
      "processedItemsCount": "Traité"
    },
    "stateLabel": "État",
    "states": {
      "INITIATED": "Initié",
      "PROCESSING": "Traitement en cours",
      "FAILED": "Échec",
      "PARTIALLY_FAILED": "Échec partiel",
      "CANCELED": "Annulé",
      "COMPLETED": "Terminé"
    },
    "objectTypeLabel": "Type",
    "items": {
      "table": {
        "batchId": "Identifiant du lot",
        "oneVestId": "Identifiant OneVest",
        "externalId": "Identifiant externe",
        "state": "État"
      },
      "requestSummaryLine": "{{queued}} en file d'attente / {{processed}} traités / {{failed}} échecs",
      "states": {
        "QUEUED": "En fille d'attente",
        "PROCESSED": "Traité",
        "FAILED": "Échec"
      },
      "upsertItemModal": {
        "title": "Détails de l'élément",
        "errorTitle": "Erreurs",
        "errorCode": "Code",
        "errorField": "Champ",
        "errorDescription": "Description",
        "summary": {
          "oneVestId": "Identifiant OneVest :",
          "batchId": "Identifiant du lot :",
          "externalId": "Identifiant externe :"
        }
      }
    }
  }
}
